import './summitlogo.less'

import {Image} from '@codeurs/front'
import BizffwdTextWhite from 'assets/images/logos/bizffwd-text-white.svg'
import DeeptechdiveTextWhite from 'assets/images/logos/deeptechdive-text-white.svg'
import FwddiveTextWhite from 'assets/images/logos/fwddive-text-white.svg'
import ItfbelgiumTextWhite from 'assets/images/logos/itfbelgium-text-white.svg'
import ItfworldTextWhite from 'assets/images/logos/itfworld-text-white.svg'
import NexgenTextWhite from 'assets/images/logos/nexgen-text-white.svg'
import SheroTextWhite from 'assets/images/logos/shero-text-white.svg'
import TinyaiTextWhite from 'assets/images/logos/tinyai-text-white.svg'
import React from 'react'
import {SummitType} from 'types'
import {style} from 'util/style'

const styles = style('summitlogo')

const logos = {
	bizffwd: {...BizffwdTextWhite, alt: 'Business Fast Forward (BIZ FFWD)'},
	deeptechdive: {...DeeptechdiveTextWhite, alt: 'Deep Tech Dive'},
	fwddive: {...FwddiveTextWhite, alt: 'Forward Dive'},
	itfbelgium: {...ItfbelgiumTextWhite, alt: 'ITF Belgium'},
	itfworld: {...ItfworldTextWhite, alt: 'ITF World'},
	tinyai: {...TinyaiTextWhite, alt: 'Tiny AI'},
	shero: {...SheroTextWhite, alt: 'SHEro'},
	nexgen: {...NexgenTextWhite, alt: 'NexGen'}
}

export const Summitlogo: React.FC<{
	summit: SummitType
}> = ({summit}) => {
	return (
		<div className={styles().mod(summit)}>
			<div className={styles('logo')}>
				<Image {...logos[summit]} alt={logos[summit].alt} />
			</div>
		</div>
	)
}
